import Typography from '@mui/material/Typography';
import { useTheme } from "@mui/material";


export default function TextCardPgx({ textcard, textcard2 }) {

    const theme = useTheme();
   
    return (

        theme.palette.mode === "light" ? (
               
          <Typography variant="subtitle1" color= 'common.black' sx={{letterSpacing: '0.05rem'}}>
              {textcard}  {textcard2}  
          </Typography>

        ) : (

        <Typography variant="subtitle1" color= 'common.white'>
            {textcard}  {textcard2}  
        </Typography>

        )

 );
}